"use client";

import React, { useEffect, useState } from "react";
import { Card, Box, Typography, Select, MenuItem, FormControl } from "@mui/material";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

const TotalCustomers = ({ data }) => {
  const [selectedPeriod, setSelectedPeriod] = useState("all");
  const [customerCount, setCustomerCount] = useState(0);

  useEffect(() => {
    if (data) {
      switch (selectedPeriod) {
        case "week":
          setCustomerCount(data.last7Days || 0);
          break;
        case "month":
          setCustomerCount(data.last30Days || 0);
          break;
        case "year":
          setCustomerCount(data.lastYear || 0);
          break;
        default:
          setCustomerCount(data.total || 0);
      }
    }
  }, [selectedPeriod, data]);

  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
  };

  return (
    <>
      <Card
        sx={{
          boxShadow: "none",
          borderRadius: "7px",
          mb: "20px",
          padding: { xs: "18px", sm: "20px", lg: "25px" },
          background: "linear-gradient(to right, #F76806, #FFA500)",
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
        className="rmui-card"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '-50px',
            left: '-50px',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.1)',
            zIndex: 0,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: '-50px',
            right: '-50px',
            width: '150px',
            height: '150px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.1)',
            zIndex: 0,
          }}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            position: "relative",
            zIndex: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flex: 1 }}>
            <PeopleAltIcon 
              sx={{ 
                fontSize: 50,
                opacity: 0.8,
                filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.1))",
                flexShrink: 0,
                color: 'rgba(255, 255, 255, 0.7)',
              }} 
            />
            <Box>
              <Typography 
                component="span" 
                sx={{ 
                  color: "white",
                  fontSize: "1rem",
                  fontWeight: 500,
                  display: "block",
                  mb: 0.5
                }}
              >
                Total Users
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  fontSize: 24,
                  fontWeight: 700,
                  color: "white",
                }}
              >
                {customerCount}
              </Typography>
            </Box>
          </Box>

          <FormControl sx={{ minWidth: 120, flexShrink: 0 }}>
            <Select
              value={selectedPeriod}
              onChange={handlePeriodChange}
              size="small"
              sx={{
                color: "white",
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.99)',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '.MuiSvgIcon-root': {
                  color: 'white',
                },
              }}
            >
              <MenuItem value="all">All Time</MenuItem>
              <MenuItem value="week">Last 7 Days</MenuItem>
              <MenuItem value="month">Last 30 Days</MenuItem>
              <MenuItem value="year">Last Year</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Card>
    </>
  );
};

export default TotalCustomers;
